<script>
	import { registerPageComplete } from '../../gtm';
    import model from '../../stores/modelStore';
	import { anonymousId } from "../../analytics";
	import { projectSettings, referralTypes } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import Person from "../../models/Person";
	import { isValid } from "../../validation";

	import Contact from "../../components/Contact.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import Claimant from "../../components/Claimant.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let disabled = null;
	export let pageTitle = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;
	export let gtmPhase = null;

	let required = true;
	let buttons = null;

    const handleSubmit = async (e) => {
    	buttons.blockNext();

		let errors = isValid();

		if (!errors.length) {
			let response = await model.saveModelAsync(persistUrl);

			if (!response.success) {
				console.log(displayError)
				//displayError(response);
			} else {
				registerPageComplete(title, gtmPhase);

				buttons.next();
			}
		} else {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		buttons.unblock();
    };

	if (!disabled) {
		$model.lastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		if (
			typeof window !== "undefined" &&
			window.analytics &&
			window.analytics.user
		) {
			$model.registrationSegmentId = anonymousId();
		}
	}

	const resetCompanyData = () => {
		$model.claimants = [ new Person() ];
		
        $model.nzbn= null;
        $model.capacityId = null;
        $model.authorisedToAct = null;
	}

	const resetSomeOneElseData = () => {
		$model.claimants = [ new Person() ];
        $model.relationshipToClaimant = null;
	}

	const handleRegistrationTypeChange = (e) => {
		
		// Need to get rid of SOMEONE Else data or Company/Business data
		switch (e.target.value){
			case registrationTypes.types.SomeoneElse.value :
				resetCompanyData();
				break;
			case registrationTypes.types.Company.value :
				resetSomeOneElseData();
				break;
			default:
				resetCompanyData();
				resetSomeOneElseData();
				break;
		}

	};

	const initialise = () => {
		if ($model && (!$model.claimants || $model.claimants.length<1)) {
			$model.claimants = [ new Person() ];
		}
	};

	initialise();
</script>

<PageSection>
	<Form {disabled} id="form-personal-details" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please provide your details</h1>
			</FormColumn>
		</FormRow>
	
		<!--<hr class="primary" />-->

		<div class="confirmation-box-shadow">

			<Contact
				bind:firstName={$model.contact.firstName}
				bind:surname={$model.contact.surname}
				bind:emailAddress={$model.contact.emailAddress}
				bind:phoneNumber={$model.contact.phoneNumber}
				bind:address={$model.contact.address}
				idPrefix="contact"
				{required}
				{disabled}
			/>

			<FormRow>
				<FormColumn>
					<Select
						{required}
						{disabled}
						label="Who are you registering for?"
						id="regType"
						bind:value={$model.registrationType}
						optionList={registrationTypes.options}
						textProperty="name"
						valueProperty="value"
						on:change={handleRegistrationTypeChange}
					/>
				</FormColumn>
			</FormRow>
		</div>

		{#if $model.registrationType && $model.registrationType != registrationTypes.types.Myself.value}
			<div class="confirmation-box-shadow">
				<div class="claimant-details">
					<Claimant
						{disabled}
						registrationType={$model.registrationType}
						bind:claimants={$model.claimants}
						bind:registration={$model}
						contactFirstName={$model.contact.firstName}
						contactSurname={$model.contact.surname}
						companyDetailRequired={true}
					/>
				</div>
			</div>
		{/if}


		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<Select
						{required}
						{disabled}
						label="Where did you hear about our firm?"
						id="whereDidYouHear"
						bind:value={$model.whereDidYouHear}
						optionList={referralTypes}
						textProperty="name"
						valueProperty="name"
					/>
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="confirmation-hide">
			<FormColumn class="last">
				<NavigationButtons bind:buttons
					nextPageLabel={$model.confirmationPage ? "Confirmation" : "Next"} />
			</FormColumn>
		</FormRow>
	</Form>

</PageSection>

<style>

	.claimant-details {
		margin-bottom: 20px;
	}

</style>
